import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import employee from '../class/employee';
import foodWarehouse from '../class/foodWarehouse';
import "../styles/ProductListPage.css";

const OrderListPage = () => {
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const fw = new foodWarehouse();
            const callData = await fw.getOrders();
            const orderList = callData?.orders || (Array.isArray(callData) ? callData : []);
            setOrders(orderList);
        } catch (error) {
            console.error("Error fetching the data", error);
        }
    };

    useEffect(() => {
        let user_obj = new employee();
        user_obj.isLogged().then(() => {
            fetchData();
        }).catch(() => {
            navigate('/login');
        });
    }, []);

    const formatDate = (ts) => {
        if (!ts) return '-';
        return moment.unix(Number(ts)).format('DD/MM/YYYY');
    };

    const handleRowClick = (order) => {
        navigate(`/orders/${order.order_uuid}`);
    };

    return (
        <div className="product-list-page">
            <div className="page-header">
                <h2 className='page-title'>Ordini da Prelevare</h2>
            </div>
            <div className="product-list">
                <div className="product-item">
                    <table>
                        <thead>
                            <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                                <th>N. Ordine Produzione</th>
                                <th>Cliente</th>
                                <th>Articolo</th>
                                <th>Stato</th>
                                <th>Data Consegna</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map(order => (
                                <tr className='order' key={order.order_uuid} onClick={() => handleRowClick(order)} style={{ cursor: 'pointer' }}>
                                    <td>{order.order_production_number}</td>
                                    <td>{order.client_name}</td>
                                    <td>{order.article_descr}</td>
                                    <td>{order.status_label}</td>
                                    <td>{formatDate(order.delivery_requested_date)}</td>
                                </tr>
                            ))}
                            {orders.length === 0 && (
                                <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Nessun ordine da prelevare</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OrderListPage;
